import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError ,Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ErrorNotificationService } from './error-notification.service';
import { AmplitudeService } from './shared/services/amplitude.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private readonly errorNotificationService: ErrorNotificationService,
        private readonly amplitudeService: AmplitudeService) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request) //it sends the updated request
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    console.log('error');
                    this.errorNotificationService.emit(error);
                    // Send error to Amplitude
                    this.amplitudeService.track('Network Error', {
                        status: error.status,
                        statusText: error.statusText,
                        endpoint: request.url,
                        method: request.method,
                        message: error.message,
                        });
                    return throwError(error);
                }))
    }
}
